import React from "react";
import { useUscSelector } from "../../../../redux/store";
import OpeningHours from "./OpeningHours";
import { UscLabel } from "../../../../utils/labels";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import * as Styles from "./PdpDealer.styles";

const DealerApprovedSales = (): JSX.Element | null => {
    const dealer = useUscSelector((state) => state.dealer.dealer);

    if (!dealer?.openingHours.length) return null;

    return (
        <Styles.ApprovedStyles>
            <Text tag="h4" variant="h6">
                <UscLabel label="uscPdpDealerOpeningHoursTitle" />
            </Text>
            <OpeningHours openingHours={dealer.openingHours} />
        </Styles.ApprovedStyles>
    );
};

export default DealerApprovedSales;
